module.exports = __webpack_public_path__ + "img/img_prodInvest_portada.43d8fd51.jpg";